<template>
  <div class="header">
    <a class="logo-box" @click="toIndex">
      <img :src="GLOBAL.UI.logo" class="logo1" style="margin-right: 3%" />
      <img :src="GLOBAL.UI.slogan" class="logo1" />
      <img :src="GLOBAL.UI.logo" class="logo2" />
    </a>
    <ul class="nav" v-if="loginInfo.department_names != null">
      <li class="nav-item">
        <a ref="ref" href="javascript:;" class="first" @click="toIndex">首页 </a>
      </li>
      <!-- <li class="nav-item" v-for="(item, key) in menus" :key="key" v-show="item.is_show_menu" :class="{ active: item.active }"> -->
      <li class="nav-item" v-for="(item, index1) in menus" :key="index1" v-show="item.is_show_menu">
        <a href="javascript:;" ref="ref1" @click="toHandle(item.menu_url, index1)" class="first">{{ item.menu_name }}</a>
        <ul class="second-nav" v-if="item.menu_url == '#'">
          <li v-for="(i, index2) in item.children" :key="index2" @click="handleCurrent($event, index1, index2, i.menu_url)" :class="{ active: current1 == index1 && current2 == index2 }">
            <a href="javascript:;" ref="ref2"> <i class="iconfont" :class="i.menu_icon"></i>{{ i.menu_name }}</a>
          </li>
        </ul>
      </li>
    </ul>
    <div class="user-box" v-if="loginInfo.department_names != null">
      <el-badge :value="all_count" class="news hand">
        <i class="iconfont icon-tubiaozhizuomoban" @click="checkMsg"></i>
      </el-badge>
      <!-- <a class="hand grayColor6" href="http://platform.5j56.com" target="_blank" style="margin-left:20px">去老平台 </a> -->

      <div class="hand grayColor6" @click="toUrl('/center/encampment')" v-if="showEncampment"><span class="toOld">|</span>添加驻场</div>
      <div class="hand grayColor6" @click="toUrl('/center/station')" v-if="showStation"><span class="toOld">|</span>土方驻场</div>
      <div class="hand grayColor6" @click="toUrl('/center/cooperation')" v-if="showHezuo"><span class="toOld">|</span>邀请合作商</div>
      <el-dropdown trigger="click">
        <span class="user">
          <i class="iconfont icon-icon4"></i>
          <em>
            <!-- {{loginInfo.department_names.join(',')}}  -->
            {{ loginInfo.user_name }} {{ loginInfo.member_code }}，您好！
          </em>
          <i class="iconfont icon-icon47"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="toUrl('/center/auth')" v-if="showZiliao">
            <i class="iconfont icon-icon77"></i>
            我的资料
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/wallet/balance-desc')" v-if="showQianbao">
            <i class="iconfont icon-icon33"></i>
            我的钱包
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/center/pay-password')" v-if="showMima">
            <i class="iconfont icon-icon32"></i>
            支付密码
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/contract/contract-list')" v-if="showHetong">
            <i class="iconfont icon-icon69"></i>
            合同管理
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/center/quanxian-list')" v-if="showQuanxian">
            <i class="iconfont icon-icon63"></i>
            权限管理
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/work/work-list')" v-if="showGongdan">
            <i class="iconfont icon-icon17"></i>
            我的工单
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/center/royalty-list')" v-if="showHuodaifei">
            <i class="iconfont icon-icon20"></i>
            货代费设置
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/oauth/update-password')">
            <i class="iconfont icon-icon43"></i>
            修改密码
          </el-dropdown-item>
          <el-dropdown-item @click.native="loginOut">
            <i class="iconfont icon-icon39"></i>
            切换账号
          </el-dropdown-item>
          <el-dropdown-item v-if="cosShow" @click.native="changeCos">
            <i class="iconfont icon-icon39"></i>
            切换{{ cos }}
          </el-dropdown-item>
          <el-dropdown-item @click.native="loginOut">
            <i class="iconfont icon-icon5"></i>
            退出系统
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog title="消息提醒" :visible.sync="msgvisible" class="dialog-lg">
      <el-tabs v-model="list_type" @tab-click="handleClick">
        <el-tab-pane label="系统通知" name="SystemNotice">
          <el-form class="search col-4 clearfix" label-position="left" label-width="70px">
            <el-row>
              <el-form-item label="日期范围" class="form-item-mid">
                <el-date-picker
                  v-model="search.value2"
                  type="daterange"
                  style="width: 100%"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                  align="right"
                  @change="getDate"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                />
              </el-form-item>
              <el-form-item label="公告类型">
                <el-select placeholder="请选择" v-model="search.notice_type" clearable>
                  <el-option label="系统通知" value="SystemNotice"></el-option>
                  <el-option label="其他通知" value="TransactionNotice"></el-option>
                  <el-option label="公共通知" value="PublicNotice"></el-option>
                </el-select>
              </el-form-item>
              <el-button type="primary" @click="searchList">搜索</el-button>
              <el-button type="info" @click="empty">清空</el-button>
            </el-row>
          </el-form>
          <el-row style="margin-bottom: 20px">
            <el-button size="small" class="fl" type="info" @click="delMoreNotice">批量删除</el-button>
            <el-button size="small" class="fl" type="info" @click="alreadyMoreNotice">批量已读</el-button>
            <el-button size="small" class="fr" type="primary" @click="alreadyAllNotice">全部已读</el-button>
          </el-row>
          <el-table class="nth" :empty-text="empty_text" border :data="notice_list" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" ref="multipleTable" height="350">
            <el-table-column type="selection" prop="notice_id" width="50" />
            <el-table-column label="时间" prop="create_time" width="100" />
            <el-table-column label="通知标题" prop="notice_title" />
            <el-table-column label="通知内容" width="300">
              <template slot-scope="scope">
                <span class="msg-active" v-if="scope.row.showMsg" v-html="scope.row.content"></span>
                <span v-else v-html="scope.row.content"></span>
              </template>
            </el-table-column>
            <el-table-column label="附件">
              <template slot-scope="scope">
                <span>{{ scope.row.file_address_text }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <span class="mainColor" v-if="scope.row.is_read == 'No'">未读</span>
                <span class="green" v-else>已读</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <el-button type="text" @click="lookOneRow(scope.row)">查看</el-button>
                <el-button type="text" @click="delOneRow(scope.row.notice_id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <paging-default :paging="search.paging" @upup="getNotice" style="margin-top: -10px"> </paging-default>
        </el-tab-pane>
        <el-tab-pane label="交易通知" name="TransactionNotice">
          <el-row style="margin-bottom: 20px">
            <el-button size="small" class="fl" type="info" @click="delMsg">批量删除</el-button>
            <el-button size="small" class="fl" type="info" @click="alreadyMsg">批量已读</el-button>
            <el-button size="small" class="fr" type="primary" @click="alreadyAllMsg">全部已读</el-button>
          </el-row>
          <el-table class="nth" :empty-text="empty_text" border :data="msg_list" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" ref="multipleTable" height="350">
            <el-table-column type="selection" width="55" />
            <el-table-column prop="create_time" label="时间" width="160" />
            <el-table-column label="内容" align="left">
              <template slot-scope="scope">
                <span class="msg-active" v-if="scope.row.showMsg" v-html="scope.row.content"></span>
                <span v-else v-html="scope.row.content"></span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <span class="mainColor" v-if="scope.row.is_read == 'No'">未读</span>
                <span class="green" v-else>已读</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <el-button type="text" @click="lookRow(scope.row)">查看</el-button>
                <el-button type="text" @click="delRow(scope.row.pid)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <paging-default :paging="searchMsg.paging" @upup="getMsg" style="margin-top: -10px"> </paging-default>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!--单条公告-->
    <el-dialog title="公告详情" :visible.sync="dialogVisible" class="dialog-sml">
      <el-form :model="addData">
        <el-row style="text-align: center">
          <p class="notice-title">{{ addData.notice_title }}</p>
          <p>
            发布者：管理员<span style="margin-left: 10px">发布时间：{{ addData.create_time }}</span>
          </p>
        </el-row>
        <el-form-item>
          <!-- <el-input type="textarea"  minlength="4" :rows="8" :autosize="{minRows: 6, maxRows: 12}" v-model="addData.content" readonly resize="none"></el-input> -->
          <div v-html="addData.content" class="content-data"></div>
        </el-form-item>
        <el-row>
          <span class="fl">附件下载：</span>
          <span v-if="addData.file_address_text == '无'">{{ addData.file_address_text }}</span>
          <span class="fl" v-else
            ><p v-for="(item, index) in addData.file_address" :key="index" @click="downLoad(item.url)" class="blue hand" style="margin: 0 0 5px 0">
              {{ item.name }}
            </p></span
          >
        </el-row>
        <!-- <el-row>
          <span>有效时间：{{addData.effective_time_start}}至{{addData.effective_time_end}}</span>
          <span></span>
        </el-row> -->
      </el-form>
      <el-row class="btn-group sm">
        <el-button type="primary" @click="seeMoreNotice">查看历史</el-button>
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="温馨提醒" :visible.sync="expire_news" class="dialog-sm">
      <span>尊敬的平台用户：您好！有{{ due_soon_length }}份合同即将到期，有{{ invalid_length }}份已到期，请尽快前往【合同管理】中处理，避免给您造成不必要的麻烦！</span>
      <el-row class="btn-group sm">
        <el-button type="primary" @click="toContract">立即处理</el-button>
        <!-- <el-button type="info" @click="version.is_news = false">取 消</el-button> -->
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { service_const } from '@/assets/js/consts'
import { openLogin, removeStorage, refreshLoginInfo, isSuccess, isLogin } from '@/assets/js/utils'
import moment from 'moment'
let newnotify
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今 天',
            onClick(picker) {
              let end = new Date()
              let start = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '本 周',
            onClick(picker) {
              let end = new Date()
              let start = new Date()
              let sum = start.getDay() //获取当前星期
              if (sum == 0) {
                sum = 7
              }
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (sum - 1))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '本 月',
            onClick(picker) {
              let end = new Date()
              let start = new Date()
              let sum = start.getDate() //获取当前日
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (sum - 1))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上 月',
            onClick(picker) {
              let obj = {
                starttime: '',
                endtime: ''
              }
              obj.starttime = moment(
                moment()
                  .month(moment().month() - 1)
                  .startOf('month')
                  .valueOf()
              ).format('YYYY-MM-DD')
              obj.endtime = moment(
                moment()
                  .month(moment().month() - 1)
                  .endOf('month')
                  .valueOf()
              ).format('YYYY-MM-DD')
              picker.$emit('pick', [obj.starttime, obj.endtime])
            }
          }
        ]
      },
      current1: null,
      current2: null,
      cosShow: false,
      all_count: 0,
      cos: '',
      department_code: '',
      menus: [],
      loginInfo: {},
      showHetong: false,
      showQuanxian: false,
      showGongdan: false,
      showHuodaifei: false,
      showHezuo: false,
      showEncampment: false,
      showStation: false,
      showZiliao: false,
      showQianbao: false,
      showMima: false,
      msgvisible: false,
      empty_text: '',
      handleSelection: [],
      searchMsg: {
        paging: {
          page_num: 1,
          total: 0
        }
      },
      search: {
        create_time_begin: '',
        create_time_finish: '',
        value2: '',
        notice_type: '',
        paging: {
          page_num: 1,
          total: 0
        }
      },
      msg_list: [],
      time: null,
      Tabs: [
        { label: '交易通知', name: 'TransactionNotice' },
        { label: '系统通知', name: 'SystemNotice' }
      ],
      list_type: 'SystemNotice',
      dialogVisible: false,
      addData: {},
      noticeData: {},
      notice_list: [],
      msg_count: 0,
      notice_count: 0,
      multipleSelection: [],
      expire_news: false,
      due_soon_length: '',
      invalid_length: '',
      isShow: false
    }
  },
  created() {
    console.log(_global_)
    if (isLogin()) {
      this.openNew()
      //消息数
      // this.getCount()
      //获取公告
      this.checkContract()
      this.getNewNotice()
    }
    //判断显示菜单
    api('system.account.menus').then((res) => {
      this.menus = res.data
      this.menus.forEach((item) => {
        if (item.menu_name == '抢单竞价表') {
          if (item.children.length == 1) {
            item.menu_url = item.children[0].menu_url
          }
        }
      })
    })
    if (this.$route.path !== '/oauth/pay-forget' && this.$route.path !== '/oauth/register-personal' && this.$route.path !== '/oauth/register-company') {
      refreshLoginInfo(() => {
        if (_global_.LOGIN_INFO != null) {
          this.loginInfo = _global_.LOGIN_INFO
          api('system.user.codes').then((res) => {
            _global_.CODES = res.data
            if (_global_.CODES.indexOf('NEIHEMOKUAI_WODEZILIAO') == -1) {
              this.showZiliao = false
            } else {
              this.showZiliao = true
            }
            if (_global_.CODES.indexOf('NEIHEMOKUAI_WODEQIANBAO') == -1) {
              this.showQianbao = false
            } else {
              this.showQianbao = true
            }
            if (_global_.CODES.indexOf('NEIHEMOKUAI_ZHIFUMIMA') == -1) {
              this.showMima = false
            } else {
              this.showMima = true
            }
            if (_global_.CODES.indexOf('NEIHEMOKUAI_HETONGGUANLI') == -1) {
              this.showHetong = false
            } else {
              this.showHetong = true
            }
            if (_global_.CODES.indexOf('NEIHEMOKUAI_QUANXIANGUANLI') == -1) {
              this.showQuanxian = false
            } else {
              this.showQuanxian = true
            }
            if (_global_.CODES.indexOf('WODEGONGDAN_GONGDANLIEBIAO') == -1) {
              this.showGongdan = false
            } else {
              this.showGongdan = true
            }
            if (_global_.CODES.indexOf('NEIHEMOKUAI_HUODAIFEISHEZHI') == -1) {
              this.showHuodaifei = false
            } else {
              this.showHuodaifei = true
            }
            if (_global_.CODES.indexOf('NEIHEMOKUAI_HEZUODANWEI') == -1) {
              this.showHezuo = false
            } else {
              this.showHezuo = true
            }
            if (_global_.CODES.indexOf('NEIHEMOKUAI_TIANJIAZHUCHANG') == -1) {
              this.showEncampment = false
            } else {
              this.showEncampment = true
            }
            if (_global_.CODES.indexOf('NEIHEMOKUAI_TUFANGZHUCHANG') == -1) {
              this.showStation = false
            } else {
              this.showStation = true
            }
          })
          if (_global_.CODES.indexOf('NEIHEMOKUAI_QIEHUANJUESE') == -1) {
            this.cosShow = false
          } else {
            api('auth.login.info').then((res) => {
              let data
              if ((data = isSuccess(res))) {
                if (data.is_auth == 'NotAttestation') {
                  this.cosShow = true
                  if (data.parent_dep_codes.indexOf('DELEGATE') == -1) {
                    this.cos = '委托方'
                    this.department_code = 'DELEGATE'
                  }
                  if (data.parent_dep_codes.indexOf('SHIPPER') == -1) {
                    this.cos = '承运方'
                    this.department_code = 'SHIPPER'
                  }
                  // if (data.parent_dep_codes.indexOf('PARTNERSHIP') == -1) {
                  //   this.showHuodaifei = false
                  // } else {
                  //   this.showHuodaifei = true
                  // }
                } else {
                  this.cosShow = false
                }
              }
            })
          }
        }
      })
    }
  },
  methods: {
    //tab切换状态
    handleClick(tab, event) {
      this.list_type = tab.name
      this.search.paging.page_num = 1
      if (this.list_type == 'TransactionNotice') {
        this.getMsg()
      } else {
        this.getNotice()
      }
    },
    //获取日期
    getDate(val) {
      this.search.create_time_begin = `${val[0]} 00:00:00`
      this.search.create_time_finish = `${val[1]} 23:59:59`
    },
    checkMsg() {
      if (this.list_type == 'TransactionNotice') {
        this.getMsg()
      } else {
        this.getNotice()
      }
    },
    //获取消息未读数
    getCount() {
      api('inform.count').then((res) => {
        let data
        if ((data = isSuccess(res))) {
          this.msg_count = data.all_count
          api('notice.unread.count').then((res) => {
            let data = isSuccess(res)
            this.notice_count = data
            this.all_count = this.msg_count + this.notice_count
          })
        } else {
          alert(res.msg)
        }
      })
    },
    //消息提醒
    openNew() {
      this.time = window.setInterval(() => {
        this.getNewMsg()
        this.getCount()
        this.getNewNotice()
      }, 60000)
    },
    getNewMsg() {
      //消息提醒
      api('inform.inform.push.query').then((res) => {
        let data
        if ((data = isSuccess(res))) {
          if (res.msg !== '') {
            const h = this.$createElement
            this.$notify({
              title: '消息提醒',
              dangerouslyUseHTMLString: true,
              duration: 6000,
              position: 'bottom-right',
              message: h('p', null, [
                h('span', null, res.msg),
                h(
                  'el-button',
                  {
                    style: {
                      float: 'right',
                      'margin-top': '20px'
                    },
                    attrs: {
                      size: 'small',
                      type: 'primary'
                    },
                    on: {
                      click: this.getMsg
                    }
                  },
                  '查看详情'
                )
              ])
            })
          }
        }
      })
    },
    //消息
    getMsg() {
      this.msgvisible = true
      api('inform.batch.query', this.searchMsg).then((res) => {
        let data
        if ((data = isSuccess(res))) {
          this.msg_list = data.map((item) => {
            item.showMsg = true
            return item
          })
          if (this.msg_list.length == 0) {
            this.empty_text = '暂无数据'
          }
          this.searchMsg.paging.total = res.data_total
        } else {
          alert(res.msg)
        }
      })
    },
    handleSelectionChange(val) {
      this.handleSelection = val
      console.log(this.handleSelection)
    },
    lookRow(row) {
      //已读
      let json = []
      json.push(row.pid)
      api('inform.inform.modify', { ids: json }).then((res) => {
        let data
        if ((data = isSuccess(res))) {
          // this.getMsg()
          row.showMsg = false
          //消息数
          this.getCount()
        }
      })
    },
    delRow(pid) {
      let json = []
      json.push(pid)
      api('inform.delete', { ids: json }).then((res) => {
        let data
        alert(res.msg)
        if ((data = isSuccess(res))) {
          this.getMsg()
        }
      })
    },
    //批量删除
    delMsg() {
      let json = []
      this.handleSelection.forEach((item) => {
        json.push(item.pid)
      })
      api('inform.delete', { ids: json }).then((res) => {
        let data
        alert(res.msg)
        if ((data = isSuccess(res))) {
          this.getMsg()
        }
      })
    },
    //全部已读
    alreadyAllMsg() {
      api('inform.inform.modify', { all_read: 'Yes' }).then((res) => {
        let data
        if ((data = isSuccess(res))) {
          this.getMsg()
          //消息数
          this.getCount()
        }
      })
    },
    //批量已读
    alreadyMsg() {
      let json = []
      this.handleSelection.forEach((item) => {
        json.push(item.pid)
      })
      api('inform.inform.modify', { ids: json }).then((res) => {
        let data
        if ((data = isSuccess(res))) {
          this.getMsg()
          //消息数
          this.getCount()
        }
      })
    },
    //公告**************************************************
    //获取公告
    getNewNotice() {
      api('notice.popup.query').then((res) => {
        let data
        if ((data = isSuccess(res))) {
          console.log(data.notice_id != this.noticeData.notice_id)
          if (data.notice_id != this.noticeData.notice_id) {
            this.noticeData = res.data
            this.isShow = true
            let content = ''
            content = `<div class="content">${this.noticeData.content}<el-button class="notice-button">我已知晓</el-button><div>`
            let nowDate = moment()
              .locale('zh-cn')
              .format('YYYY-MM-DD HH:mm:ss')
            if (this.noticeData.is_read == 'No') {
              // 如果不为空并且过期则不展示
              if (this.noticeData.effective_time_end != '' && nowDate > this.noticeData.effective_time_end) {
              } else {
                // const h = this.$createElement
                if (newnotify) {
                  newnotify.close()
                }
                let notify = this.$notify({
                  title: this.noticeData.notice_title,
                  dangerouslyUseHTMLString: true,
                  duration: 0,
                  position: 'bottom-right',
                  message: content
                })
                notify.$el.querySelector('el-button').onclick = () => {
                  this.seeNewNotice()
                  notify.close()
                }
                newnotify = notify
              }
            }
          }
        }
      })
    },
    // 查看最新公告
    seeNewNotice() {
      this.isShow = false
      api('notice.user.query.by.notice.id', {
        notice_id: this.noticeData.notice_id
      }).then((res) => {
        let data
        console.log((data = isSuccess(res)))
        if ((data = isSuccess(res))) {
          this.addData = data
          if (JSON.stringify(this.addData.file_address[0]) != '{}') {
            this.addData.file_address_text = '有'
          } else {
            this.addData.file_address_text = '无'
          }
          this.dialogVisible = true
        } else {
          alert(res.msg)
        }
      })
    },
    // 获取公告列表
    getNotice() {
      this.msgvisible = true
      api('notice.user.list', this.search).then((res) => {
        let data = isSuccess(res)
        if (res.code == 200) this._isdisabled = true
        this.notice_list = data
        this.notice_list = data.map((item) => {
          item.showMsg = true
          if (JSON.stringify(item.file_address[0]) != '{}') {
            item.file_address_text = '有'
          } else {
            item.file_address_text = '无'
          }
          return item
        })
        if (this.notice_list.length == 0) {
          this.empty_text = '暂无数据'
        }
        this.search.paging.total = res.data_total
      })
    },
    // 查看单条记录
    lookOneRow(row) {
      api('notice.user.query.by.notice.id', { notice_id: row.notice_id }).then((res) => {
        let data
        if ((data = isSuccess(res))) {
          this.addData = data
          if (JSON.stringify(this.addData.file_address[0]) != '{}') {
            this.addData.file_address_text = '有'
          } else {
            this.addData.file_address_text = '无'
          }
          this.dialogVisible = true
        } else {
          alert(res.msg)
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //删除
    delOneRow(id) {
      let json = [id]
      if (confirm('确认删除？')) {
        api('notice.notice.account.delete', { ids: json }).then((res) => {
          let data
          alert(res.msg)
          if ((data = isSuccess(res))) {
            this.getNotice()
          }
        })
      }
    },
    //多个删除
    delMoreNotice() {
      console.log(this.multipleSelection)
      if (this.multipleSelection.length == 0) {
        alert('请勾选删除项')
        return false
      } else {
        if (confirm('确认删除？')) {
          let noticeIidArr = []
          this.multipleSelection.forEach((item) => {
            noticeIidArr.push(item.notice_id)
          })
          api('notice.notice.account.delete', { ids: noticeIidArr }).then((res) => {
            let data
            alert(res.msg)
            if ((data = isSuccess(res))) {
              this.getNotice()
            }
          })
        }
      }
    },
    //批量已读
    alreadyMoreNotice() {
      console.log(this.multipleSelection)
      if (this.multipleSelection.length == 0) {
        alert('请勾选')
        return false
      } else {
        let json = []
        this.multipleSelection.forEach((item) => {
          json.push(item.notice_id)
        })
        api('notice.batch.read', { ids: json }).then((res) => {
          let data
          alert(res.msg)
          if ((data = isSuccess(res))) {
            this.getNotice()
          }
        })
      }
    },
    //全部已读
    alreadyAllNotice() {
      api('notice.batch.all.read').then((res) => {
        let data
        alert(res.msg)
        if ((data = isSuccess(res))) {
          this.getNotice()
        }
      })
    },
    // 下载附件
    downLoad(url) {
      api('notice.download.count', { notice_id: this.addData.notice_id }).then((res) => {
        let data
        if ((data = isSuccess(res))) {
          window.open(url)
        } else {
          alert(res.msg)
        }
      })
    },
    // 查看更多历史消息
    seeMoreNotice() {
      this.dialogVisible = false
      this.msgvisible = true
      this.list_type = 'SystemNotice'
      this.getNotice()
    },
    empty() {
      this.search.value2 = ''
      this.search.create_time_begin = ''
      this.search.create_time_finish = ''
      this.search.notice_type = ''
      this.searchList()
    },
    searchList() {
      this.search.paging.page_num = 1
      if (this._isdisabled) {
        this.getNotice()
        this._isdisabled = false
      }
    },
    toIndex() {
      toUrl('/')
      this.$refs.ref1.forEach((item) => {
        item.style.color = 'black'
      })
      this.$refs.ref.style.color = 'red'
    },
    toHandle(url, index1) {
      if (url !== '#') {
        this.current1 = index1
        console.log(this.$refs.ref1)
        this.$refs.ref1.forEach((item) => {
          item.style.color = 'black'
        })
        this.$refs.ref2.forEach((item) => {
          if (item.style.color == 'red') {
            item.style.color = 'black'
          }
        })
        this.$refs.ref.style.color = 'black'
        this.$refs.ref1[index1].style.color = 'red'
        toUrl(url)
      }
    },
    changeCos() {
      api('account.change.department', {
        department_code: this.department_code
      }).then((res) => {
        let data
        alert(res.msg)
        if ((data = isSuccess(res))) {
          let t1 = window.setTimeout(function() {
            window.location.reload()
          }, 2000)
        }
      })
    },
    loginOut() {
      removeStorage(service_const.tokenKey)
      clearInterval(this.time)
      openLogin()
    },
    handleCurrent(e, val1, val2, url) {
      this.$refs.ref1.forEach((item) => {
        item.style.color = 'black'
      })
      this.$refs.ref2.forEach((item) => {
        if (item.style.color == 'red') {
          item.style.color = 'black'
        }
      })
      this.$refs.ref.style.color = 'black'
      this.current1 = val1
      this.current2 = val2
      this.$refs.ref1[val1].style.color = 'red'
      toUrl(url)
    },
    checkContract() {
      api('contract.contract.renewal.count').then((res) => {
        let data
        if ((data = isSuccess(res))) {
          if (data.due_soon_count > 0 || data.invalid_count > 0) {
            this.expire_news = true
            this.due_soon_length = data.due_soon_count
            this.invalid_length = data.invalid_count
          }
        }
      })
    },
    toContract() {
      toUrl('/contract/contract-list')
      this.expire_news = false
    }
  }
}
</script>
<style>
.content-data {
  border: 1px solid #f2f2f2;
  padding: 5px 15px;
}
.content-data ul li {
  list-style: decimal;
}
.content-data ol li {
  list-style: disc;
}
.content ul li {
  list-style: decimal;
}
.content ol li {
  list-style: disc;
}
.content {
  width: 280px;
}
.notice-button {
  background: #0088f5;
  color: #fff;
  margin-left: 30%;
  padding: 5px 15px;
  border-radius: 5px;
  cursor: pointer;
  display: inline-block;
  margin-top: 15px;
}
</style>
<style scoped lang="scss">
@import 'src/assets/sass/mixin';
//隐藏内容
.msg-active {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
// .msg-noactive {
//   overflow: auto;
//   background: #000;
// }
/*头部通用样式*/
.head-fixed {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.header {
  height: 100%;
}
.logo-box {
  display: flex;
  align-items: center;
  height: 80px;
  position: absolute;
  left: 30px;
  top: 0;
}
.logo-text {
  font-size: 15px;
  color: #000;
  font-weight: bold;
}
.nav {
  display: flex;
  align-items: center;
  // width: 1200px;
  margin: 0 auto;
}
@media screen and (min-width: 1680px) {
  .nav {
    margin-left: 22%;
  }
}

@media screen and (max-width: 1679px) {
  .nav {
    margin-left: 12%;
  }
}
.nav-item {
  position: relative;
}
.nav-item > a {
  display: flex;
  align-items: center;
  height: 80px;
  font-size: 15px;
  padding: 0 15px;
}
.nav-item.active > a {
  color: $mainColor;
  font-weight: bold;
}
.nav-item:hover .second-nav {
  left: 25px;
}
.nav-item:hover > a {
  color: $mainColor;
  //font-weight: bold;
}

.second-nav {
  position: absolute;
  left: -9999em;
  top: 75px;
  z-index: 9;
  background: #fff;
  box-shadow: 0 0 10px #e5e5e5;
  padding: 10px 0;
  z-index: 99999;
}
.second-nav:after {
  content: '';
  position: absolute;
  top: -5px;
  left: 8px;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  background: #fff;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.second-nav a {
  display: inline-block;
  width: 160px;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  font-size: 14px;
}
.second-nav .active > a {
  color: $mainColor;
}
.second-nav li i {
  margin-right: 8px;
  font-size: 20px;
  vertical-align: middle;
}
.second-nav li a:hover {
  color: $mainColor;
}
.second-nav li a:hover i {
  color: $mainColor;
}
.first:hover {
  color: $mainColor;
}
.user-box {
  position: absolute;
  right: 30px;
  top: 0;
  height: 80px;
  display: flex;
  align-items: center;
}
.user-box i {
  font-size: 22px;
  color: $mainColor;
  vertical-align: middle;
}
.user {
  position: relative;
}
.user em {
  margin-left: 5px;
}
.el-dropdown-menu__item i {
  font-size: 20px;
  vertical-align: middle;
}
.yaoqing {
  position: absolute;
  top: 39px;
  left: -39%;
  font-size: 16px;
}
@media screen and (max-width: 1680px) {
  .logo1 {
    display: none;
  }
}
@media screen and (min-width: 1680px) {
  .logo2 {
    display: none;
  }
}
.grayColor6 {
  margin-right: 10px;
  color: #606266;
}
.toOld {
  padding-right: 10px;
  color: #e5e5e5;
}
.yulan {
  top: -15px;
}
.yu-btn {
  position: absolute;
  top: 0;
  right: 65%;
  font-size: 14px;
  color: #cc0816;
  // position: relative;
}
.blue {
  color: #409eff;
}
.notice-title {
  font-size: 20px;
  // font-weight: bold;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/master/master-head-navigation.vue